import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './7e4249c09dbaf35f4155f47f1056af9a9a19ef62a5ae12cdd081d72f211b2d63.cfe-internal.js';
import Switch from './bf16bbf807668894b4c889c48d317f23363f829ce2b3afc9eea48eb5350af15e.cfe-internal.js';
import '../Label/ccb438053671d3f4f4866aeae6546c2d1a0a64aa48a3d0efdd175e4b2c5ded2e.cfe-internal.js';
import Label from '../Label/9a6a268368a265bce1daf89b3b2abe908557e75abd2903920d33084576c4c867.cfe-internal.js';

var _excluded = ["id", "label", "className", "checked", "defaultChecked", "disabled", "onChange", "value", "inputProps", "aria-describedby"];
var SwitchField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    className = _ref.className,
    checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    value = _ref.value,
    inputProps = _ref.inputProps,
    ariaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Label, _extends({}, rest, {
    ref: ref,
    htmlFor: id,
    className: classNames(className, styles.label, _defineProperty({}, styles.labelDisabled, disabled))
  }), /*#__PURE__*/React__default.createElement(Switch, {
    inputProps: inputProps,
    className: styles.wrappedInput,
    id: id,
    checked: checked,
    defaultChecked: defaultChecked,
    onChange: onChange,
    disabled: disabled,
    value: value,
    "aria-describedby": ariaDescribedBy
  }), label);
});

export { SwitchField as default };
